import{getCssPropertyValue as r}from"../utils/css.js";function t(t){return r("direction",t)}export{t as getElementLanguageDirection};
